import { render, staticRenderFns } from "./dj-media-upload-header.vue?vue&type=template&id=4ff21dec&scoped=true&"
import script from "./dj-media-upload-header.vue?vue&type=script&lang=js&"
export * from "./dj-media-upload-header.vue?vue&type=script&lang=js&"
import style0 from "./dj-media-upload-header.vue?vue&type=style&index=0&id=4ff21dec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff21dec",
  null
  
)

export default component.exports